import { IForm } from 'core-components/classes/models/IForm'

import { DropdownBase } from './DropdownBase'
import { IDropdownProps } from './models/IDropdownProps'

export const Dropdown = <T = IForm,>(props: IDropdownProps<T>) => {
  return <DropdownBase<T> {...props} />
}
